
export interface FormTaskState {
  sendTaskContents: { [id: number]: {comment: string} };
}

export const initialFormTaskState: FormTaskState = {
  sendTaskContents: {},
};
